import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PutRequest } from "../../services/ApiClientService"
import type { EEnableStatusType } from "../../Enum/EEnableStatusType"

export interface ProductQuickEditItem {
  id: number
  name: string
  valueBase: number
  status: EEnableStatusType
  categoryId: number
  hasStockControl: boolean
  stockQuantity: number
  needFulfillment: boolean
  hasPreparationTime: boolean
  preparationTimeMinutes: number
}

interface ProductQuickEditRequest {
  items: ProductQuickEditItem[]
}

export const useQuickEditProducts = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleQuickEditProducts = async (items: ProductQuickEditItem[], onSuccess: () => Promise<void>): Promise<boolean> => {
    try {
      enableLoad()

      const response = await PutRequest<number[], ProductQuickEditRequest>(API_ROUTES.PRODUCT.QUICK_EDIT, { items })

      if (!response.success) throw new Error(response.message)

      await onSuccess()

      return true
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { handleQuickEditProducts }
}
